export default {"src":"/_next/static/media/mapPinIcon.e90da1fe.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};